import React from 'react'
import LeftArrow from 'components/icons/LeftArrow'
import {
  Container,
  LeftSection,
  RightSection,
  SectionName,
  TopHeading,
} from './style'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import { useNavigate } from 'react-router-dom'

const Header = ({
  form,
  setIsFieldsMandatory,
  isEditing,
  eventStatus,
}) => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate(-1)
  }

  return (
    <Container spaceBetween>
      <LeftSection centerVertically>
        <div style={{ cursor: 'pointer' }}>
          <LeftArrow onClick={handleBackClick} />
        </div>
        <SectionName column>
          <RoutePath from="Events" path="/events" />
          <TopHeading>{eventStatus === 0 ? 'New Event (Duplicate)'  : eventStatus === 1 ? 'Edit Event' : 'New Event'} </TopHeading>
        </SectionName>
      </LeftSection>
      <RightSection>
        {(!isEditing || eventStatus === 0) && (
          <Button.Secondary
            text="Save"
            form={form}
            name="eventForm"
            onClick={() => {
              setIsFieldsMandatory(false)
            }}
            htmlType="submit"
          />
        )}
        <Button.Primary
          text={'Preview'}
          form={form}
          name="eventForm"
          onClick={() => {
            setIsFieldsMandatory(true)
          }}
          htmlType="submit"
        />
      </RightSection>
    </Container>
  )
}
export default Header
